import { Module } from '@nestjs/common';
import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { TypeOrmModule } from '@nestjs/typeorm';
import { EmployeeDetailsAdapter } from './dto/employee-details.adapter';
import { EmployeeDetailsController } from './employee-details.controller';
import { EmployeeDetails } from './employee-details.entity';
import { EmployeeDetailsService } from './employee-details.service';
import { EmployeeService } from '@gtpl/shared-services/attendance';
import { Departments } from '../departments/departments.entity';
import { EmployeeRepo } from './dto/employee.repository';
import { DepartmentService } from '@gtpl/shared-services/masters';
import { AttendanceService, DesignationService, PayrollProcessServices, TeamCalenderService } from '@gtpl/shared-services/hrms';
import { WhatsAppNotificationService } from '@gtpl/shared-services/notification-management';
import { AttendanceHelperService } from 'apps/services/hrms/src/app/attendance/attendance-helper.service';


@Module({
  imports: [
    TypeOrmModule.forFeature([EmployeeDetails, Departments, EmployeeRepo,]),
  ],
  controllers: [EmployeeDetailsController],
  providers: [EmployeeDetailsService, EmployeeDetailsAdapter, ApplicationExceptionHandler, EmployeeService, DepartmentService, AttendanceService,PayrollProcessServices,WhatsAppNotificationService,DesignationService],
  exports: [EmployeeDetailsService,]
})
export class EmployeeDetailsModule {



}
